import React from "react";
import "../styles/about.css"; 

export default function About() {
  return (
    <div className="about-container">
      <h1>Über uns</h1>
      <p className="about-slogan">
        <strong>Ernährung neu gedacht – einfach, persönlich, wirksam.</strong>
      </p>

      <section className="about-section">
        <h2>Unsere Vision</h2>
        <p>
          Dein Körper ist dein Tempel, der tägliche Pflege und Erneuerung verdient. ReYou liefert die personalisierten Bausteine – fundierte Informationen, smarte Ernährungsvorschläge und intuitive Begleitung –, damit du jeden Tag dich bewusst neu gestalten kannst.
        </p>
      </section>

      <section className="about-section">
        <h2>Unsere Kernwerte</h2>
        <ul className="core-values">
          <li>
            <strong>Erneuerung:</strong> <br />
            Kleine, tägliche Schritte führen zu großen Veränderungen. Jeder Biss und jede Mahlzeit ist ein kleiner Schritt der Erneuerung.
          </li>
          <li>
            <strong>Einfachheit:</strong> <br />
            Schnell, persönlich-passend und abwechslungsreich liefert dir ReYou das Rezept, für dich und deine Familie in Sekunden. Kein Tracking, keine Box und kein Fertiggericht. Du kochst und wir unterstützen dich.
          </li>
          <li>
            <strong>Achtsamkeit:</strong> <br />
            Bewusstes Genießen statt hektischer Diät-Quickies. Jeder Bissen ist Teil deiner täglichen Self-Care-Rituale.
          </li>
          <li>
            <strong>Selbstwirksamkeit:</strong> <br />
            Du behältst die volle Kontrolle über deine Ernährung und deine Daten. Du kaufst ein und kochst, wir helfen dir mit allem anderen.
          </li>
        </ul>
      </section>

      <section className="about-section">
        <h2>Warum jetzt?</h2>
        <p>
          In einer Welt voller Empfehlungen, Experten und Trends brauchst du einen klaren Kompass. ReYou liefert dir in Sekunden wissenschaftlich fundierte und personalisierte Rezepte. Deine Aufmerksamkeit und Zeit gehört dir.
        </p>
      </section>

      <section className="about-section">
        <h2>Herkunft &amp; Gründung</h2>
        <p>
          2025 in Düsseldorf gegründet, entstand ReYou aus der gemeinsamen Leidenschaft für Performance und Alltagstauglichkeit. Zwei Gründer, ein Ziel: die Brücke zwischen ernährungswissenschaftlicher Exzellenz und dem täglichen Leben zu schlagen.
        </p>
        <p>
          Getrieben durch die eigenen Erfahrungen im Alltag zwischen Job, Familie und persönlichen Zielen, gepaart mit der Leidenschaft für künstliche Intelligenz, wurde die erste Idee von Lars und Philipp beim Urlaub in den Alpen geboren.
        </p>
      </section>

      <section className="about-section">
        <h2>Vertrauen &amp; Datenschutz</h2>
        <p>
          Entwickelt in Deutschland, mit EU-weiten Serverstandorten und durchgängig DSGVO-konform. Deine Daten werden verschlüsselt übertragen, nur das Nötigste gespeichert und jederzeit auf Wunsch gelöscht.
        </p>
      </section>

      <div className="about-cta">
        <p><strong>Rebuild yourself and redefine you today.</strong></p>
        <p>Beginne jetzt deine tägliche Reise der Erneuerung – mit ReYou an deiner Seite.</p>
      </div>
    </div>
  );
}
